import ENUMS from "../utils/ENUMS.js"
import jwt_decode from "jwt-decode";

export const setAuth = (data) => {
    localStorage.removeItem(ENUMS.AUTH);
    localStorage.setItem(ENUMS.AUTH, data);
}


export const processLogout = () => {
   localStorage.clear()
    window.location.href = '/'
}


export const getToken = () => {
    const token = localStorage.getItem(ENUMS.AUTH);
    if (!token) return null;
    return token;
}


const decodeJWT = () => {
    // If invalid token then return null
    try {

        const token = getToken();

        if (!token) return null;

        // Check whether the token is valid
        jwt_decode(token, {header: true});

        // If valid send the payload
        return jwt_decode(token);


    } catch (e) {
        // Token is invalid
        return null;
    }

}


export const isAuthenticated = () => {
    const authDecoded = decodeJWT();
    // console.log(authDecoded.exp," ,",Date.now(), "auth")
    if (authDecoded?.exp * 1000 < Date.now()) {
        processLogout();
    }
    return !!authDecoded;
}


export const getAuthData = () => {
    return decodeJWT();
}
